export default __webpack_public_path__ + "static/media/Flaticon2.41914745.ttf";